import { createComponent as _$createComponent } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { template as _$template } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<section class="rounded-default border-2 border-neutral-300 bg-white shadow-lg overflow-hidden"><header class="px-5 py-3 border-b-4 border-primary bg-white"><div class="text-3xl font-display text-primary uppercase leading-tight"></div><div class="mt-1 flex items-baseline justify-between gap-4 flex-wrap"><div class="flex items-baseline gap-3 flex-wrap"><h2 class="text-xl font-bold text-text-heading"></h2><span class="text-sm text-neutral-500"></span></div><div class="flex items-center gap-3 text-xs uppercase text-neutral-500"><span></span></div></div></header><div class="p-4"></div></section>`);
var _tmpl$2 = /*#__PURE__*/_$template(`<span>-</span>`);
var _tmpl$3 = /*#__PURE__*/_$template(`<span>RTL</span>`);
var _tmpl$4 = /*#__PURE__*/_$template(`<div class="text-center text-neutral-500 py-8 text-sm">No participants in this lineup yet.</div>`);
var _tmpl$5 = /*#__PURE__*/_$template(`<div></div>`);
var _tmpl$6 = /*#__PURE__*/_$template(`<div class="rounded-default border border-neutral-300 bg-neutral-50 px-3 py-2 flex items-center gap-3 min-w-0"><div class="flex-none w-10 h-10 rounded-default bg-neutral-800 text-white font-bold text-lg flex items-center justify-center tabular-nums"></div><div class="min-w-0 flex-1"><div class="font-display font-extrabold text-2xl text-text-heading leading-none">#</div><div class="text-xs text-neutral-600 truncate mt-0.5"></div></div></div>`);
var _tmpl$7 = /*#__PURE__*/_$template(`<div class="p-4 sm:p-6 max-w-screen-2xl mx-auto"><h1 class="font-bold text-2xl text-text-heading">Live Lineups</h1><div class="mt-8 text-center text-neutral-500 py-16">Loading lineups…</div></div>`);
var _tmpl$8 = /*#__PURE__*/_$template(`<div class="p-4 sm:p-6 max-w-screen-2xl mx-auto"><header class="flex items-center justify-between gap-4 flex-wrap mb-6"><div><h1 class="font-bold text-2xl text-text-heading">Live Lineups</h1><p class="text-xs text-neutral-500 mt-0.5">Pick an organization to see what's currently posted on track.</p></div><div class="flex items-center gap-3 flex-wrap"><div class="font-bold text-2xl tabular-nums text-neutral-700"></div><label class="inline-flex items-center gap-2 text-xs uppercase text-neutral-600 cursor-pointer select-none"><input type="checkbox" class="accent-primary"></input>Auto-refresh</label><button type="button" class="inline-flex items-center gap-1 text-xs text-neutral-700 hover:text-neutral-900 border border-neutral-300 px-3 py-1.5 rounded-default bg-white hover:bg-neutral-50 cursor-pointer"><!>Refresh</button></div></header><div class="mb-6 max-w-md"><label class="block text-xs uppercase text-neutral-500 mb-1">Organization</label></div><!><!><!><!><div class="mt-10 pt-6 border-t border-neutral-200 text-xs text-neutral-500"><p>Embedding this data on your own site? See the public API:</p><pre class="mt-2 p-3 bg-neutral-100 rounded-default font-mono text-2xs overflow-x-auto"><code></code></pre></div></div>`);
var _tmpl$9 = /*#__PURE__*/_$template(`<div class="rounded-default border-2 border-dashed border-neutral-300 bg-white p-12 text-center"><div class="font-bold text-2xl text-neutral-500 mb-2">No organizations available</div></div>`);
var _tmpl$10 = /*#__PURE__*/_$template(`<div class="text-center text-neutral-500 py-12">Loading...</div>`);
var _tmpl$11 = /*#__PURE__*/_$template(`<div class="rounded-default border-2 border-dashed border-neutral-300 bg-white p-12 text-center"><div class="font-bold text-2xl text-neutral-500 mb-2">No lineups posted</div><div class="text-sm text-neutral-500">This organization hasn't published any lineups right now. Check back later.</div></div>`);
var _tmpl$12 = /*#__PURE__*/_$template(`<div class="grid grid-cols-1 xl:grid-cols-2 gap-4 sm:gap-6"></div>`);
import { createSignal, createEffect, createMemo, onCleanup, onMount, For, Show } from "solid-js";
import { FormCombobox } from "../../ui/Forms.ts";
import { Icon } from "../../ui/Icons.ts";
const STORAGE_KEY_ORG = "public.lineups.selectedOrgId";
const REFRESH_MS = 15e3;
function gridColsClass(width) {
  const w = Math.max(1, Math.min(8, width || 2));
  const map = {
    1: "grid grid-cols-1",
    2: "grid grid-cols-2",
    3: "grid grid-cols-3",
    4: "grid grid-cols-4",
    5: "grid grid-cols-5",
    6: "grid grid-cols-6",
    7: "grid grid-cols-7",
    8: "grid grid-cols-8"
  };
  return map[w] || map[2];
}
function LineupCard(props) {
  const grid = createMemo(() => {
    const sec = props.section;
    const sorted = (sec.participants || []).slice().sort((a, b) => {
      const ap = a.start_position ?? Number.MAX_SAFE_INTEGER;
      const bp = b.start_position ?? Number.MAX_SAFE_INTEGER;
      return ap - bp;
    });
    if (sec.sbs_right_to_left) {
      const w = Math.max(1, sec.car_width || 2);
      const out = [];
      for (let i = 0; i < sorted.length; i += w) {
        out.push(...sorted.slice(i, i + w).reverse());
      }
      return out;
    }
    return sorted;
  });
  return (() => { var _el$ = _tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$2.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling, _el$8 = _el$6.firstChild, _el$9 = _el$8.nextSibling, _el$10 = _el$7.firstChild; _$insert(_el$4, () => props.section.class_name); _$insert(_el$8, () => props.section.session_name); _$insert(_el$9, () => props.section.event_name); _$insert(_el$10, () => props.section.lap_count > 0 ? props.section.lap_count + " laps" : "no laps"); _$insert(_el$7, _$createComponent(Show, { get when() { return props.section.sbs_right_to_left; }, get children() { return [_tmpl$2(), _tmpl$3()]; } }), null); _$insert(_el$3, _$createComponent(Show, { get when() { return grid().length > 0; }, get fallback() { return _tmpl$4(); }, get children() { return (() => { var _el$ = _tmpl$5(); _$effect(() => _$setAttribute(_el$, "class", gridColsClass(props.section.car_width) + " gap-2")); _$insert(_el$, _$createComponent(For, { get each() { return grid(); }, get children() { return (p) => (() => { var _el$ = _tmpl$6(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling; _$insert(_el$2, () => p.start_position ?? "-"); _$insert(_el$4, () => p.car_number, null); _$insert(_el$5, () => p.driver_name); return _el$; })(); } })); return _el$; })(); } })); return _el$; })();
}
function Lineups() {
  if (globalThis.__SSR__) {
    return _tmpl$7();
  }
  const [orgs, setOrgs] = createSignal([]);
  const [orgsLoaded, setOrgsLoaded] = createSignal(false);
  const initialOrgID = (() => {
    try {
      return localStorage.getItem(STORAGE_KEY_ORG) || "";
    } catch {
      return "";
    }
  })();
  const [selectedOrgID, setSelectedOrgID] = createSignal(initialOrgID);
  const [sections, setSections] = createSignal([]);
  const [loading, setLoading] = createSignal(false);
  const [now, setNow] = createSignal(/* @__PURE__ */ new Date());
  const [autoRefresh, setAutoRefresh] = createSignal(true);
  createEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY_ORG, selectedOrgID() || "");
    } catch {
    }
  });
  const orgOptions = createMemo(() => orgs().map((o) => ({ value: o.id, label: o.name })));
  onMount(async () => {
    try {
      const res = await fetch("/api/public/orgs");
      if (!res.ok) throw new Error();
      const list = await res.json();
      setOrgs(list || []);
      if (!selectedOrgID() && list.length > 0) {
        setSelectedOrgID(list[0].id);
      } else if (selectedOrgID() && !list.some((o) => o.id === selectedOrgID())) {
        setSelectedOrgID(list[0]?.id || "");
      }
    } catch {
      setOrgs([]);
    } finally {
      setOrgsLoaded(true);
    }
  });
  let requestId = 0;
  const load = async () => {
    const orgID = selectedOrgID();
    if (!orgID) {
      setSections([]);
      return;
    }
    const myReq = ++requestId;
    setLoading(true);
    try {
      const res = await fetch(`/api/public/orgs/${encodeURIComponent(orgID)}/lineups`);
      if (myReq !== requestId) return;
      if (!res.ok) {
        setSections([]);
        return;
      }
      setSections(await res.json());
    } catch {
      if (myReq === requestId) setSections([]);
    } finally {
      if (myReq === requestId) setLoading(false);
    }
  };
  createEffect(() => {
    void selectedOrgID();
    load();
  });
  let refreshTimer = null;
  let clockTimer = null;
  onMount(() => {
    clockTimer = setInterval(() => setNow(/* @__PURE__ */ new Date()), 1e3);
  });
  createEffect(() => {
    if (refreshTimer !== null) {
      clearInterval(refreshTimer);
      refreshTimer = null;
    }
    if (autoRefresh() && selectedOrgID()) {
      refreshTimer = setInterval(() => load(), REFRESH_MS);
    }
  });
  onCleanup(() => {
    if (refreshTimer !== null) clearInterval(refreshTimer);
    if (clockTimer !== null) clearInterval(clockTimer);
  });
  const clockLabel = createMemo(() => {
    const d = now();
    const hh = d.getHours().toString().padStart(2, "0");
    const mm = d.getMinutes().toString().padStart(2, "0");
    const ss = d.getSeconds().toString().padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  });
  return (() => { var _el$ = _tmpl$8(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.nextSibling, _el$5 = _el$4.nextSibling, _el$6 = _el$5.nextSibling, _el$7 = _el$6.nextSibling, _el$8 = _el$7.nextSibling, _el$9 = _el$2.firstChild, _el$10 = _el$9.nextSibling, _el$11 = _el$10.firstChild, _el$12 = _el$11.nextSibling, _el$13 = _el$12.nextSibling, _el$14 = _el$12.firstChild, _el$15 = _el$13.firstChild, _el$16 = _el$8.firstChild, _el$17 = _el$16.nextSibling, _el$18 = _el$17.firstChild; _$insert(_el$11, () => clockLabel()); _$effect(() => _$setAttribute(_el$14, "checked", autoRefresh())); _el$14.addEventListener("change", (e) => setAutoRefresh(e.currentTarget.checked)); _el$13.addEventListener("click", (_e) => load()); _$insert(_el$13, _$createComponent(Icon, { icon: "rotate", get size() { return 12; } }), _el$15); _$insert(_el$3, _$createComponent(FormCombobox, { get options() { return orgOptions(); }, get value() { return selectedOrgID(); }, get onChange() { return (v) => setSelectedOrgID(v); }, get searchable() { return true; }, searchPlaceholder: "Search organizations...", placeholder: "Select organization..." }), null); _$insert(_el$, _$createComponent(Show, { get when() { return orgsLoaded() && orgs().length === 0; }, get children() { return _tmpl$9(); } }), _el$4); _$insert(_el$, _$createComponent(Show, { get when() { return loading() && sections().length === 0; }, get children() { return _tmpl$10(); } }), _el$5); _$insert(_el$, _$createComponent(Show, { get when() { return !loading() && selectedOrgID() && sections().length === 0; }, get children() { return _tmpl$11(); } }), _el$6); _$insert(_el$, _$createComponent(Show, { get when() { return sections().length > 0; }, get children() { return (() => { var _el$ = _tmpl$12(); _$insert(_el$, _$createComponent(For, { get each() { return sections(); }, get children() { return (section) => _$createComponent(LineupCard, { get section() { return section; } }); } })); return _el$; })(); } }), _el$7); _$insert(_el$18, "GET /api/public/orgs\nGET /api/public/orgs/{org_id}/lineups"); return _el$; })();
}
export {
  Lineups
};
